export default "__VITE_ASSET__d220ed08__"